export default "__VITE_ASSET__B$PEBsbJ__"